import React, {useEffect} from "react";
import {useAnalytics} from "@unibuddy/tracking";

import {TrackEvents} from "ubcommunity-shared/src/constants";
import {useLocationQuery} from "ubcommunity-shared/src/Hooks/useLocationQuery";
import {Landing as LandingContent} from "ubcommunity-shared/src/Auth/Landing/Landing";
import {usePageTitle} from "ubcommunity-shared/src/Hooks/usePageTitle";

export default function Landing() {
    const {trackEvent} = useAnalytics();

    usePageTitle();

    const query = useLocationQuery();
    const source = query.get("source");

    useEffect(() => {
        trackEvent(TrackEvents.WELCOME_PAGE_OPENED, {
            source: source || "university",
        });
    }, [trackEvent, source]);

    return <LandingContent />;
}
